import type { FaireProductEntity } from "../../entity_types/product";

export const p_c5xfa64hga: FaireProductEntity = {
  token: "p_c5xfa64hga",
  type: "product",
  name: "Konosuba: God's Blessing on This Wonderful World!, Vol. 8",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/f36f2886ac5cd4d69db2b25f56c450bade7513d77417acb5dfc9576d73874368.webp",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "After Yunyun proclaims her desire to bear Kazuma's child, she wastes no time fleeing to her hometown-the Crimson Magic Clan's village! Kazuma and the gang chase after her, but the path is rougher than he imagined...Wait, who's offering to have his kids now?!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:38.170Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
